import React from 'react';

const GoogleRatings = () => (
  <svg
    width="80"
    height="12"
    viewBox="0 0 80 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.90954 9.64421L10.8127 12L9.77691 7.56L13.2253 4.57263L8.68428 4.18737L6.90954 0L5.1348 4.18737L0.59375 4.57263L4.04217 7.56L3.00638 12L6.90954 9.64421Z"
      fill="#FBBC04"
    />
    <path
      d="M23.5424 9.64421L27.4455 12L26.4097 7.56L29.8581 4.57263L25.3171 4.18737L23.5424 0L21.7676 4.18737L17.2266 4.57263L20.675 7.56L19.6392 12L23.5424 9.64421Z"
      fill="#FBBC04"
    />
    <path
      d="M40.1713 9.64421L44.0744 12L43.0386 7.56L46.487 4.57263L41.946 4.18737L40.1713 0L38.3965 4.18737L33.8555 4.57263L37.3039 7.56L36.2681 12L40.1713 9.64421Z"
      fill="#FBBC04"
    />
    <path
      d="M56.8041 9.64421L60.7072 12L59.6714 7.56L63.1199 4.57263L58.5788 4.18737L56.8041 0L55.0293 4.18737L50.4883 4.57263L53.9367 7.56L52.9009 12L56.8041 9.64421Z"
      fill="#FBBC04"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.4369 9.64421V0L71.6621 4.18737L67.1211 4.57263L70.5695 7.56L69.5337 12L73.4369 9.64421Z"
      fill="#FBBC04"
    />
    <path
      d="M73.4369 9.64421L77.34 12L76.3043 7.56L79.7527 4.57263L75.2116 4.18737L73.4369 0V9.64421Z"
      fill="#DADCE0"
    />
  </svg>
);

GoogleRatings.displayName = 'GoogleRatings';
export default GoogleRatings;
